window._ = require('lodash')
window.axios = require('axios')
window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest'

import Vue from 'vue'
import App from './App.vue'
import router from './router'

// Import iview setting
import { locale } from 'view-design'
import lang from 'view-design/dist/locale/ja-JP'
locale(lang)
// Import iview custom css
import './assets/iview.less'

import store from './store'

// Import default app css
require('@/assets/sass/app.scss')

Vue.directive('scroll', {
  inserted: function(el, binding) {
    let f = function(evt) {
      if (binding.value(evt, el)) {
        window.removeEventListener('scroll', f)
      }
    }
    window.addEventListener('scroll', f)
  },
})

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app')
